import React from 'react'

const UploadIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={25}
      height={22}
      fill="none"
      {...props}
    >
      <path
        fill="#fff"
        d="M0 11.445c0-2.304 1.377-4.111 3.584-4.453.049-2.744 2.852-4.463 5.068-3.867C9.824 1.416 11.71 0 14.356 0c3.994 0 7.128 3.145 7.109 7.5 1.904.771 3.086 2.393 3.086 4.365 0 2.364-1.797 4.17-4.795 4.17h-6.66v-5.264l-.059-1.455.547.577 1.504 1.61a.733.733 0 0 0 .537.235c.4 0 .713-.293.713-.683 0-.215-.088-.371-.235-.518l-3.222-3.105c-.196-.196-.361-.254-.557-.254-.205 0-.37.058-.566.254l-3.223 3.105c-.146.147-.234.303-.234.518 0 .39.293.683.703.683.195 0 .4-.078.537-.234l1.514-1.611.547-.577-.059 1.455v5.264h1.553v4.248a.77.77 0 0 1-.772.752c-.42 0-.781-.342-.781-.752v-4.248H5.107c-3.203 0-5.107-2.05-5.107-4.59Z"
      />
    </svg>
  )
}

export default UploadIcon
